import React from "react";
import { Eye } from "lucide-react";

const statusLabels = {
  NOT_STARTED: "Non demarre",
  IN_PROGRESS: "En cours",
  COMPLETED: "Termine",
  PASSED: "Reussi",
  FAILED: "Echoue",
};

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("fr-FR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
};

const formatScore = (row) => {
  const score = row.scoreScaled != null ? row.scoreScaled * 100 : row.scoreRaw;
  return score == null ? "-" : `${Math.round(score * 10) / 10}`;
};

const formatTime = (seconds) => {
  if (!seconds) return "0 min";
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return hours > 0 ? `${hours}h ${rest}min` : `${rest} min`;
};

export default function ScormProgressTable({ rows, onOpenDetail }) {
  if (!rows?.length) {
    return <div className="scorm-report-empty">Aucune progression SCORM a afficher.</div>;
  }

  return (
    <div className="scorm-report-table-wrap">
      <table className="scorm-report-table">
        <thead>
          <tr>
            <th>Collaborateur</th>
            <th>Contenu</th>
            <th>Statut</th>
            <th>Progression</th>
            <th>Score</th>
            <th>Temps</th>
            <th>Dernier acces</th>
            <th>SCO courant</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.userId}-${row.contentId}`}>
              <td>
                <strong>{row.fullName || `${row.firstName || ""} ${row.lastName || ""}`}</strong>
                <span>{row.email}</span>
              </td>
              <td>{row.contentTitle}</td>
              <td>
                <span className={`scorm-status scorm-status-${String(row.status).toLowerCase()}`}>
                  {statusLabels[row.status] || row.status}
                </span>
              </td>
              <td>
                <div className="scorm-progress-cell">
                  <div style={{ width: `${Math.max(0, Math.min(row.completionPercent || 0, 100))}%` }} />
                </div>
                <span className="scorm-progress-label">{row.completionPercent || 0}%</span>
              </td>
              <td>{formatScore(row)}</td>
              <td>{formatTime(row.timeSpentSeconds)}</td>
              <td>{formatDate(row.lastAccessAt)}</td>
              <td>{row.currentNodeTitle || row.currentScoTitle || "-"}</td>
              <td>
                <button className="scorm-icon-button" type="button" onClick={() => onOpenDetail(row.userId)} title="Voir le detail">
                  <Eye size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
